import axios from 'axios';
import { API_BASE_URL } from '../config';

// OSS Policy 签名信息接口
interface OSSPolicyResponse {
    keyId: string;
    policy: string;
    signature: string;
    dir: string;
    host: string;
    expire: string;
}

// 文件上传响应接口
interface UploadFileResponse {
    url: string;
    path: string;
    access_control: string;
    content_type: string;
}

// 获取 OSS Policy 签名信息
export async function getOSSPolicy(type: 'audio' | 'doc' | 'picture' | 'other' | 'video'): Promise<OSSPolicyResponse> {
    const response = await axios.get(`${API_BASE_URL}/api/v1/aliyun/oss?type=${type}`);
    return response.data.data;
}

// 使用新接口上传文件
export async function uploadFile(
    file: File, 
    fileType: 'audio' | 'doc' | 'picture' | 'other' | 'video',
    accessControl: 'public-read' | 'private' = 'private'
): Promise<string> {
    try {
        const formData = new FormData();
        formData.append('file', file);

        const response = await axios.post<{code: number; message: string; data: UploadFileResponse}>(
            `${API_BASE_URL}/api/v1/aliyun/oss/upload?file_type=${fileType}&access_control=${accessControl}`,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            }
        );

        if (response.data.code !== 200) {
            throw new Error(response.data.message);
        }

        return response.data.data.url;
    } catch (error) {
        console.error('上传失败:', error);
        throw error;
    }
}

// 上传文件到 OSS (旧方法保留向后兼容)
export async function uploadToOSS(file: File): Promise<string> {
    try {
        // 获取 Policy 签名信息
        const policy = await getOSSPolicy('picture');
        
        // 构建 FormData
        const formData = new FormData();
        const fileName = `${Date.now()}-${file.name}`;
        const key = `${policy.dir}/${fileName}`;

        formData.append('key', key);
        formData.append('OSSAccessKeyId', policy.keyId);
        formData.append('policy', policy.policy);
        formData.append('Signature', policy.signature);
        formData.append('success_action_status', '200');
        formData.append('file', file);

        // 发送上传请求
        await axios.post(policy.host, formData);

        // 返回文件的访问 URL（从 host 中提取 bucket 和 endpoint）
        const fileUrl = `https://consultation-backend.zhi-yuan.net/api/v1/aliyun/authorization?objectKey=${key}`;
        
        return fileUrl;
    } catch (error) {
        console.error('上传失败:', error);
        throw error;
    }
} 